import { darken } from "polished";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding-left: 10px;
  cursor: pointer;
  color: #fff;
`;

export const AvatarCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    darken(0.04, theme.colors.background.grundfos.primary)};
  padding-top: 12px;
`;

export const AvatarCircleWithoutPadding = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    darken(0.04, theme.colors.background.grundfos.primary)};
`;

export const Name = styled.div`
  font-size: 14px;
  padding-left: ${({ theme }) => theme.spacing[3]};

  @media (max-width: 1048px) {
    display: none;
  }
`;

export const LogoutButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  padding-right: 12px;
`;

export const LogoutModal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 200px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  padding: ${({ theme }) => theme.spacing[3]};
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme }) => theme.spacing[1]};
  animation: fadeIn 0.3s ease-in-out;
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
`;

export const LogoutNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.spacing[2]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  border-radius: ${({ theme }) => theme.spacing[1]};
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[1]};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.layers[600]};
  }
`;

export const LogoutNavText = styled.span`
  font-size: 14px;
  transition: background-color 0.2s ease-in-out;
  padding-left: ${({ theme }) => theme.spacing[3]};
`;

export const LogoutNavIcon = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
